
 const number_reg = /^[0-9]*$/; // Allows only English numerals

// export  const number_reg = /^[\u0621-\u064A\u0660-\u0669a-zA-Z0-9\s]*$/;
export const number_reg_arabic = /^[0-9\u0660-\u0669]+$/; // allow arabic and english text

export function arabicNumbersToEnglish(str) {
     
    

   
        let result = "";

    for (let i = 0; i <  str.length; i++) {
      let char = str[i];
      console.log('str in loop',str);
  
      if (char === "٠") result += "0";
      else if (char === "١") result += "1";
      else if (char === "٢") result += "2";
      else if (char === "٣") result += "3";
      else if (char === "٤") result += "4";
      else if (char === "٥") result += "5";
      else if (char === "٦") result += "6";
      else if (char === "٧") result += "7";
      else if (char === "٨") result += "8";
      else if (char === "٩") result += "9";
      else result += char; // Keep the character if it's not an Arabic number
    }
  
     return result;
    // setValue(result);
   // }
  // else return '';
    
  }

  // old 
// export default function FormikHandleChange(e,formik){
//     if(number_reg.test(e.target.value)==true){
//       formik.handleChange(e);
//      } 

// }

export default function FormikHandleChange(e,formik){
  if(number_reg_arabic.test(e.target.value)==true){
    let text=arabicNumbersToEnglish(e.target.value);

    e.target.value=text;
    console.log("text",text)
    formik.handleChange(e);
   }
   else{
    if(e.target.value==''){
      formik.handleChange(e);
    }
   }

}

export function HandleNumberChange(setValue,e){
    if(number_reg_arabic.test(e.target.value)==true){
      let text=arabicNumbersToEnglish(e.target.value);
        setValue(text);
       }
    else{
      if(e.target.value==''){
        setValue(e.target.value);
      }
    } 
}
